<template>
  <div :class="[$style.cell_tooltip_wrap]">
    <div
      ref="cell"
      :class="[$style.cell_tooltip_trigger]"
      @mouseenter="onMouseenter"
      @mouseleave="onMouseleve"
    >
      <slot />
    </div>

    <div
      v-show="canShow && isShow && items && items.length"
      ref="cellTooltip"
      :class="[
        'table_cell_tooltip',
        isShow && 'visible',
        $style.cell_tooltip,
        !isByTop ? $style.cell_tooltip_bottom : ''
      ]"
      :style="{ width: width + 'px' }"
    >
      <div
        :class="$style.cell_tooltip_pointer"
        :style="{ left: triggerCoords.left + 15 + 'px',
                  top: isByTop ? triggerCoords.top - 7 + 'px' : triggerCoords.bottom - 2 + 'px' }"
      />
      <div
        v-for="group in groupSet"
        :key="componentKey + group"
      >
        <div
          v-if="group"
          :class="$style.select_group"
        >
          <span> {{ group }} </span>
          <div :class="$style.select_group_line" />
        </div>

        <div
          v-for="(item, index) in getGroupItems(group)"
          :key="componentKey + '-' + index"
          :class="$style.tooltip_item"
        >
          <template v-if="template === 'text'">
            <span :class="$style.text_wrap">
              {{ item[valueField] }}
            </span>
          </template>
          <template v-if="template === 'label'">
            <div
              :style="{'background-color': item.color}"
              :class="[$style.square]"
            />
            <span :class="$style.text_wrap">
              {{ item[valueField] }}
            </span>
          </template>
          <template v-if="template === 'icon+text'">
            <div
              :style="{'background-image': `url(${item[iconField]})`}"
              :class="[$style.icon_wrap]"
            />
            <span :class="$style.text_wrap">
              {{ item[valueField] }}
            </span>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TooltipCell',
  props: {
    items: { type: Array, required: false },
    groupBy: { type: String, required: false, default: 'group' },
    iconField: { type: String, required: false, default: 'icon' },
    valueField: { type: String, required: false, default: 'value' },
    template: {
      type: String,
      required: false,
      default: 'text',
      validator(value) {
        return ['text', 'label', 'icon+text'].indexOf(value) !== -1;
      },
    },
    width: { type: Number, required: false, default: 221 },
    canShow: { type: Boolean, required: false, default: true },
  },
  data() {
    return {
      triggerCoords: {},
      isShow: false,
      cursorOnElem: false,
      isByTop: true,
    };
  },

  computed: {
    groupSet() {
      if (!this.items && !this.items.length) return [];

      const set = [];

      this.items.forEach(item => {
        const groupName = this.groupBy in item ? item[this.groupBy] : null;

        if (!set.includes(groupName)) {
          set.push(groupName);
        }
      });

      return set;
    },
    componentKey() {
      const min = 1000;
      const max = 100000;

      return Math.floor(Math.random() * (max - min)) + min;
    },
  },
  mounted() {
    window.addEventListener('wheel', this.onMouseleve);
  },
  beforeUnmount() {
    window.removeEventListener('wheel', this.onMouseleve);
  },
  methods: {
    calcPosition() {
      if (!this.$refs.cell || !this.$refs.cellTooltip) {
        return;
      }

      this.triggerCoords = this.$refs.cell.getBoundingClientRect();
      const clientWidth = document.body.clientWidth;
      const clientHeight = document.body.clientHeight;
      const isByRight = this.triggerCoords.left + this.width + 0 > clientWidth;
      const cellTooltip = this.$refs.cellTooltip;
      const isByTop = this.triggerCoords.top > cellTooltip.clientHeight;

      cellTooltip.style.left = isByRight ? 'auto' : `${this.triggerCoords.left}px`;
      cellTooltip.style.right = isByRight ? '0px' : 'auto';
      cellTooltip.style.bottom = isByTop ? `${clientHeight - this.triggerCoords.top + 2}px` : 'auto';
      cellTooltip.style.top = isByTop ? 'auto' : `${this.triggerCoords.bottom + 2}px`;

      this.isByTop = isByTop;
    },
    getGroupItems(groupName) {
      if (groupName === null) {
        return this.items.filter(item => !(this.groupBy in item));
      }

      return this.items.filter(item => item[this.groupBy] === groupName);
    },
    onMouseenter() {
      this.cursorOnElem = true;

      setTimeout(() => {
        if (!this.cursorOnElem) return;

        this.isShow = true;
        this.$nextTick(() => {
          this.calcPosition();
        });
      }, 1000);
    },
    onMouseleve() {
      this.cursorOnElem = false;
      this.isShow = false;
    },
  },
};
</script>

<style module src="./cell.less" lang="less" />
